import { render, staticRenderFns } from "./AddRxProviderModal.vue?vue&type=template&id=04e82eb2"
import script from "./AddRxProviderModal.vue?vue&type=script&lang=ts"
export * from "./AddRxProviderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports